exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__wrapper___2IAQP .index-module__top___ulyv-{display:flex;flex-direction:column}.index-module__wrapper___2IAQP .index-module__top___ulyv- h1{font-size:32px;font-weight:600;margin-bottom:.3rem}.index-module__wrapper___2IAQP .index-module__top___ulyv- p{font-size:15px;font-weight:400;color:#707070;margin-bottom:.8rem}.index-module__wrapper___2IAQP img{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;border-radius:5px;margin-bottom:1rem}", ""]);

// exports
exports.locals = {
	"wrapper": "index-module__wrapper___2IAQP",
	"top": "index-module__top___ulyv-"
};